var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833252 10.0007C0.833252 4.93804 4.93731 0.833984 9.99992 0.833984C15.0625 0.833984 19.1666 4.93804 19.1666 10.0007C19.1666 15.0633 15.0625 19.1673 9.99992 19.1673C4.93731 19.1673 0.833252 15.0633 0.833252 10.0007ZM9.99992 9.58398C10.4602 9.58398 10.8333 9.95708 10.8333 10.4173V13.334C10.8333 13.7942 10.4602 14.1673 9.99992 14.1673C9.53968 14.1673 9.16659 13.7942 9.16659 13.334V10.4173C9.16659 9.95708 9.53968 9.58398 9.99992 9.58398ZM9.99992 7.91732C10.6903 7.91732 11.2499 7.35767 11.2499 6.66732C11.2499 5.97696 10.6903 5.41732 9.99992 5.41732C9.30956 5.41732 8.74992 5.97696 8.74992 6.66732C8.74992 7.35767 9.30956 7.91732 9.99992 7.91732Z",
    fill: "#D0CCE5",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.1e65fcbc09196a67ad4b163d5182cbdd.svg";
export { ForwardRef as ReactComponent };